import usePermissions from 'api/usePermissions';
import { useUserDetails } from 'api/useUserDetails';
import { permissionsUtil } from 'utils/permissionsUtil';
import { getSelectProjectOptions } from 'utils/projectsUtil';

export function useAllowedPublisherForProjects() {
  const { userDetails } = useUserDetails();
  const projectsDetails = userDetails?.projects || [];

  const { getPermissions } = usePermissions();
  const permissions = getPermissions();
  const allowedPublishers =
    permissionsUtil.getAccessPublisherOrders(permissions);

  const allowedProjects = getSelectProjectOptions(
    projectsDetails,
    allowedPublishers
  ).map((project) => project.value);

  return { allowedProjects };
}
